import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { Masks, MaskService } from 'src/app/shared/services/mask.service';
import { KitWithItemsStruct } from 'src/app/shared/services/structs/pharmacy/kit-with-items.struct';
import { KitItemsModalComponent } from '../../kit-items-modal/kit-items-modal.component';
import { dateHourInCrescentOrderValidator } from 'src/app/shared/custom-validators/date-hour-form-array-order.validator';
import { ObservationScheduling } from 'src/app/shared/services/models/bed/observation-scheduling.model';
import { FrequencyEnum } from 'src/app/shared/enum/medical-record/frequency.enum';
import { KitMultiselectStruct } from 'src/app/shared/services/structs/pharmacy/kit-multiselect.struct';
import { ItemService } from 'src/app/shared/services/API/pharmacy/Item.service';
import { KitService } from 'src/app/shared/services/API/pharmacy/kit.service';
import { ItemModel } from 'src/app/shared/services/models/pharmacy/item.model';
import { MaterialItemKitRequests } from 'src/app/shared/services/requests/pharmacy/request-material.request';
import { StatusSchedulingEnum } from 'src/app/shared/enum/medical-record/status-scheduling.enum';
import { minOneHourDifferenceValidator } from 'src/app/shared/custom-validators/min-one-hor-difference.validator';
import { PrescriptionsSuspensionCofirmModalComponent } from '../../prescriptions-suspension-cofirm-modal/prescriptions-suspension-cofirm-modal.component';
import { UtilService } from 'src/app/shared/services/util.service';
import { UserRoleEnum } from 'src/app/shared/enum/user-role.enum';
import { PrescriptionMedicineStruct } from 'src/app/shared/services/structs/pharmacy/prescription-medicine.struct';
import { PrescriptionMedicineCheckStruct } from 'src/app/shared/services/structs/pharmacy/prescription-medicine-check.struct';

@Component({
    selector: 'app-prescription-scheduling-modal',
    templateUrl: './prescription-scheduling-modal.component.html',
    styleUrls: ['./prescription-scheduling-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrescriptionSchedulingModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<PrescriptionSchedulingModalComponent>,
    private formBuilder: FormBuilder,
    private maskService: MaskService,
    private alertService: AlertService,
    public itemService: ItemService,
    public kitService: KitService,
    private utilService: UtilService,
  ) { }

  public frequencyEnum: typeof FrequencyEnum = FrequencyEnum;
  public statusSchedulingEnum: typeof StatusSchedulingEnum = StatusSchedulingEnum;
  public userRoleEnum: typeof UserRoleEnum = UserRoleEnum;

  public model: FormGroup;
  public masks: Masks;

  public listKits: KitMultiselectStruct[] = [];
  public listItems: ItemModel[] = [];

  public prescriptionMedicineStruct: PrescriptionMedicineStruct = null;
  public observationScheduling: ObservationScheduling;

  public isLoading: boolean = false;
  public firstLoading: boolean = true;
  public hasActionsButton: boolean = false;
  public buttonToSaveDisabled: boolean = false;
  public userCanSuspended: boolean = true;

  public prescriptionType: number;
  public cycleTime: number;

  public startDateCycle: Date;
  public limitDate: Date;

  ngOnInit(): void {
    this.firstLoading = false;
    this.userCanSuspended = this.utilService.getRoles().find(x => x.idRole == this.userRoleEnum.therapy_scheduling_nurse_can_suspended) ? true : false;
    this.model = this.formBuilder.group({
      listSchedulingDate: this.formBuilder.array([], {
        validators: [dateHourInCrescentOrderValidator, minOneHourDifferenceValidator]
      }),
      observation: [""],
      listMaterials: this.formBuilder.array([]),
    });

    this.observationScheduling = this.data.observationScheduling;
    this.cycleTime = this.data.cycleTime;
    this.startDateCycle = this.data.startDateCycle;
    this.prescriptionType = this.data.prescriptionType;

    if (this.data && this.data.prescriptionItem) {
      this.prescriptionMedicineStruct = this.data.prescriptionItem;
      if (this.prescriptionMedicineStruct.prescriptionMedicine.idFrequency == this.frequencyEnum.criterioMedico
        || this.prescriptionMedicineStruct.prescriptionMedicine.idFrequency == this.frequencyEnum.seNecessario
        || this.prescriptionMedicineStruct.prescriptionMedicine.idFrequency == this.frequencyEnum.continuo)
        this.hasActionsButton = true;
    }

    this.masks = this.maskService.getMasks();
    this.populateKitList();
    this.populateItemList();
    this.populate();
  }

  submit() {
    //colocar lógica de reaprazamento depois
    const listSchedulingDateForm = this.model.get('listSchedulingDate') as FormArray;

    if (listSchedulingDateForm.hasError('minOneHourDifference')) {
      listSchedulingDateForm.controls.forEach(control => {
        control.get('hour')?.markAsTouched();
        control.get('hour')?.markAsDirty();
      });

      this.alertService.show('Erro', "Os horários devem ter pelo menos 1 hora de diferença!", AlertType.error);
      return;
    }
    if (listSchedulingDateForm.errors?.dateLessThanCurrentDate) {
      this.alertService.show('Erro', "As datas não podem ser menores que a data de hoje!", AlertType.error);
      return;
    }

    if (this.model.invalid) {
      this.alertService.show('Erro', "Preencha todos os campos obrigatórios!", AlertType.error);
      return;
    }

    if (listSchedulingDateForm) {

      let inclusionDatePrescription = new Date(this.prescriptionMedicineStruct.datetimeInclusion);
      const firstDateValue = listSchedulingDateForm.at(0).get('date').value.toString();
      const firstHourValue = listSchedulingDateForm.at(0).value.hour.toString();
      if (!listSchedulingDateForm.at(0).get('id').value && !this.validFirstDate(firstDateValue, firstHourValue, inclusionDatePrescription)) {
        this.alertService.show('Erro', "Não é possível definir um horário inicial superior às 24h da criação da prescrição!", AlertType.error);
        return;
      }

      this.prescriptionMedicineStruct.listPrescriptionMedicineCheck = this.prescriptionMedicineStruct.listPrescriptionMedicineCheck.filter(x => x.prescriptionMedicineCheck.idPrescriptionMedicineCheck);

      listSchedulingDateForm.getRawValue().forEach(x => {
        if(x.id)
          return;
        
        var prescriptionMedicineCheckStruct = new PrescriptionMedicineCheckStruct();

        let day = parseInt(x.date.substring(0, 2), 10);
        let month = parseInt(x.date.substring(2, 4), 10) - 1; // Mês é base zero
        let year = parseInt(x.date.substring(4), 10);
        let hour = parseInt(x.hour.substring(0, 2), 10);
        let minute = parseInt(x.hour.substring(2, 4), 10);

        prescriptionMedicineCheckStruct.prescriptionMedicineCheck.datetimeCheckEstimative = new Date(year, month, day, hour, minute, 0);
        prescriptionMedicineCheckStruct.prescriptionMedicineCheck.schedulingObservation = this.model.get('observation').value;
        prescriptionMedicineCheckStruct.prescriptionMedicineCheck.idStatusScheduling = this.statusSchedulingEnum.Aprazado;
        this.prescriptionMedicineStruct.listPrescriptionMedicineCheck.push(prescriptionMedicineCheckStruct);
      });
    }
    if (this.model.get('listMaterials')) {
      this.prescriptionMedicineStruct.listMaterialItemKitRequests = [];
      this.model.get('listMaterials').value.forEach(x => {
        let requestItemKit = new MaterialItemKitRequests;
        requestItemKit.idRequestMaterialItemKit = x.idRequestMaterialItemKit;
        requestItemKit.idRequestMaterial = x.idRequestMaterial;
        let kitItem = x.kitItem.split('null')
        requestItemKit.idKit = kitItem[0] ? parseInt(kitItem[0]) : null;
        requestItemKit.idItem = kitItem[1] ? parseInt(kitItem[1]) : null;
        requestItemKit.quantity = x.quantity;
        if (requestItemKit.quantity <= 0) {
          this.alertService.show('Erro', "É necessário adicionar ao menos um item em cada material", AlertType.error);
          this.isLoading = false;
          return;
        }
        this.prescriptionMedicineStruct.listMaterialItemKitRequests.push(requestItemKit);
      });
    }
    this.matDialogRef.close({ prescription: this.prescriptionMedicineStruct });
  }

  populate() {
    let listModelSchedulingDate = (this.model.controls['listSchedulingDate'] as FormArray);
    let listModelMaterials = (this.model.controls['listMaterials'] as FormArray);
    let inputDisable: boolean = false;
    this.limitDate = new Date(this.prescriptionMedicineStruct.datetimeInclusion);
    this.limitDate.setHours(this.limitDate.getHours() + 24);
    let startDate = new Date();
    startDate.setSeconds(0);
    startDate.setMinutes(startDate.getMinutes() + 10);

    //array de data
    if (this.prescriptionMedicineStruct.listPrescriptionMedicineCheck
      && this.prescriptionMedicineStruct.listPrescriptionMedicineCheck.length > 0) {

      this.prescriptionMedicineStruct.listPrescriptionMedicineCheck.forEach(x => {
        if (x.prescriptionMedicineCheck.idPrescriptionMedicineCheck) {
          inputDisable = true;
        }
        x.prescriptionMedicineCheck.datetimeCheckEstimative = new Date(x.prescriptionMedicineCheck.datetimeCheckEstimative);
        listModelSchedulingDate.push(
          this.createInputDate(inputDisable, x.prescriptionMedicineCheck.datetimeCheckEstimative, x.prescriptionMedicineCheck.idPrescriptionMedicineCheck)
        );
        inputDisable = false;
        if (this.observationScheduling.blockTimeEditingScheduling && !this.hasActionsButton){
          inputDisable = true;
        }
        if (x.prescriptionMedicineCheck.idPrescriptionMedicineCheck 
          && (!this.prescriptionMedicineStruct.prescriptionMedicine.idSubFrequency 
            || (this.prescriptionMedicineStruct.subFrequencyValue && this.prescriptionMedicineStruct.listPrescriptionMedicineCheck.length == this.prescriptionMedicineStruct.subFrequencyValue)))
          this.buttonToSaveDisabled = true;
      });
      this.model.get('observation').setValue(this.prescriptionMedicineStruct.listPrescriptionMedicineCheck[0].prescriptionMedicineCheck.schedulingObservation);
    } else if (this.prescriptionMedicineStruct.prescriptionMedicine.idFrequency == this.frequencyEnum.x1Horas) {

      for (let i = 0; i < this.cycleTime; i++) {
        if(startDate > this.limitDate)
          break;
        listModelSchedulingDate.push(
          this.createInputDate(inputDisable, new Date(startDate))
        );
        startDate.setHours(startDate.getHours() + 1);
        if (this.observationScheduling.blockTimeEditingScheduling)
          inputDisable = true;
      }
    } else if (this.prescriptionMedicineStruct.prescriptionMedicine.idFrequency == this.frequencyEnum.continuo) {

      listModelSchedulingDate.push(
        this.createInputDate(inputDisable, new Date(startDate), null, true)
      );
      
    } else if (this.prescriptionMedicineStruct.frequencyValue != null && this.prescriptionMedicineStruct.frequencyValue > 1) {

      for (let i = 0; i < this.cycleTime; i += this.prescriptionMedicineStruct.frequencyValue) {
        if(startDate > this.limitDate)
          break;
        listModelSchedulingDate.push(
          this.createInputDate(inputDisable, new Date(startDate))
        );
        startDate.setHours(startDate.getHours() + this.prescriptionMedicineStruct.frequencyValue);
        if (this.observationScheduling.blockTimeEditingScheduling)
          inputDisable = true;
      }
    } else {
      this.addNextInputDate();
    }
    //array de itens adicionais
    if (this.prescriptionMedicineStruct.listMaterialItemKitRequests) {
      this.prescriptionMedicineStruct.listMaterialItemKitRequests.forEach(x => {
        let idItem = x.idKit ? x.idKit + 'null' : 'null' + x.idItem;
        listModelMaterials.push(
          this.createInputMaterial(x, idItem)
        );
        if (this.observationScheduling.blockTimeEditingScheduling)
          inputDisable = true;
      });
    }

    this.model.get('listSchedulingDate').updateValueAndValidity();
  }

  close() {
    this.matDialogRef.close();
  }

  createInputDate(disabled: boolean, datetimeCheckEstimative?: Date, idPrescriptionMedicineCheck?: number, withoutHour?: boolean) {
    if (datetimeCheckEstimative != null && withoutHour) {
      return this.formBuilder.group({
        id: [{ value: idPrescriptionMedicineCheck, disabled: disabled}],
        date: [{ value: `${(datetimeCheckEstimative.getDate()).toString().padStart(2, '0')}${(datetimeCheckEstimative.getMonth() + 1).toString().padStart(2, '0')}${datetimeCheckEstimative.getFullYear()}`, disabled: disabled }, Validators.required],
        hour: [{ value: '', disabled: disabled }, Validators.required],
      });
    } else if (datetimeCheckEstimative != null) {
      return this.formBuilder.group({
        id: [{ value: idPrescriptionMedicineCheck, disabled: disabled}],
        date: [{ value: `${(datetimeCheckEstimative.getDate()).toString().padStart(2, '0')}${(datetimeCheckEstimative.getMonth() + 1).toString().padStart(2, '0')}${datetimeCheckEstimative.getFullYear()}`, disabled: disabled }, Validators.required],
        hour: [{ value: `${(datetimeCheckEstimative.getHours()).toString().padStart(2, '0')}${(datetimeCheckEstimative.getMinutes()).toString().padStart(2, '0')}`, disabled: disabled }, Validators.required],
      });
    }
    else {
      return this.formBuilder.group({
        id: [{ value: null, disabled: disabled}],
        date: [{ value: '', disabled: disabled }, Validators.required],
        hour: [{ value: '', disabled: disabled }, Validators.required],
      });
    }
  }

  addNextInputDate() {
    (this.model.controls['listSchedulingDate'] as FormArray).push(this.createInputDate(false));
    this.model.get('listSchedulingDate').updateValueAndValidity();
  }

  removeLastSchedulingDate() {
    const list = this.model.get('listSchedulingDate') as FormArray;
    if (list.length > 1) 
      list.removeAt(list.length - 1); 

    this.model.get('listSchedulingDate').updateValueAndValidity();
  }

  createInputMaterial(item?: MaterialItemKitRequests, idItem?: string) {
    if (item != null) {
      return this.formBuilder.group({
        kitItem: [idItem, [Validators.required]],
        quantity: [item.quantity, [Validators.required]],
        idRequestMaterialItemKit: [item.idRequestMaterialItemKit],
        idRequestMaterial: [item.idRequestMaterial]
      });
    }
    else {
      return this.formBuilder.group({
        kitItem: [null, [Validators.required]],
        quantity: [null, [Validators.required]],
        idRequestMaterialItemKit: [null],
        idRequestMaterial: [null]
      })
    }
  }

  addNextInputMaterial() {
    (this.model.controls['listMaterials'] as FormArray).push(this.createInputMaterial());
  }

  removeInputMaterial(index: number) {
    (this.model.controls['listMaterials'] as FormArray).removeAt(index);
    if (this.model.get('listMaterials')['controls'].length == 0 && index != 0)
      this.addNextInputMaterial();

  }

  openKit(kit: KitWithItemsStruct) {
    const dialogRef = this.dialog.open(KitItemsModalComponent, {
      width: "700px",
      data: {
        kit: kit,
      },
    });
  }

  populateKitList() {
    this.kitService.listAllKit().subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        if (response.list && response.list.length > 0) {
          this.listKits = response.list;
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  populateItemList() {
    this.itemService.listAllItem().subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }
        this.listItems = response.listItem;
      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  validFirstDate(firstDateValue: string, firstHourValue: string, dateTimeInclusion: Date): boolean {
    const day = parseInt(firstDateValue.substring(0, 2), 10);
    const month = parseInt(firstDateValue.substring(2, 4), 10) - 1; // Mês é base zero
    const year = parseInt(firstDateValue.substring(4), 10);
    const hour = parseInt(firstHourValue.substring(0, 2), 10);
    const minute = parseInt(firstHourValue.substring(2, 4), 10);
    const firstDateInput = new Date(year, month, day, hour, minute, 0);
    dateTimeInclusion.setHours(dateTimeInclusion.getHours() + 24)
    if (firstDateInput.getTime() < dateTimeInclusion.getTime())
      return true;
    else
      return false;
  }

  changeFirstInput() {
    if(this.prescriptionMedicineStruct.frequencyValue == null 
      || this.prescriptionMedicineStruct.frequencyValue < 1
      || (this.prescriptionMedicineStruct.frequencyValue == 1 && this.prescriptionMedicineStruct.prescriptionMedicine.idFrequency != this.frequencyEnum.x1Horas))
      return;

    const listModelSchedulingDate = this.model.get('listSchedulingDate') as FormArray;
    let inputDisable: boolean = false;

    const firstGroup = listModelSchedulingDate.at(0) as FormGroup;
    const dateStr = firstGroup.get('date')?.value;
    const hourStr = firstGroup.get('hour')?.value;

    if (!dateStr || !hourStr) return;
    // const novaData = new Date(`${dataStr}T${horaStr}:00`);

    let startDate = this.calculateDate(dateStr, hourStr);
    if (isNaN(startDate.getTime())) return;

    listModelSchedulingDate.clear(); 

    for (let i = 0; i < this.cycleTime; i += this.prescriptionMedicineStruct.frequencyValue) {
      if(i > 0 && startDate > this.limitDate)
        break;
      listModelSchedulingDate.push(
        this.createInputDate(inputDisable, new Date(startDate))
      );
      startDate.setHours(startDate.getHours() + this.prescriptionMedicineStruct.frequencyValue);
      if (this.observationScheduling.blockTimeEditingScheduling)
        inputDisable = true;
    }

  }

  calculateDate(firstDate: string, firstHour: string) {
    let day = parseInt(firstDate.substring(0, 2), 10);
    let month = parseInt(firstDate.substring(2, 4), 10) - 1;
    let year = parseInt(firstDate.substring(4), 10);
    let hour = parseInt(firstHour.substring(0, 2), 10);
    let minute = parseInt(firstHour.substring(2, 4), 10);

    return new Date(year, month, day, hour, minute);
  }
  
  openPrescriptionModal() {
    const dialogRef = this.dialog.open(PrescriptionsSuspensionCofirmModalComponent, {
      data: {
        prescription: this.prescriptionMedicineStruct,
        isMedicatedSolution: false,
      },
      panelClass: 'prescriptions-suspension-confirm'
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.medicalPrescriptionToSuspend) {
          this.prescriptionMedicineStruct.prescriptionMedicine.motiveSuspended = result.medicalPrescriptionToSuspend.prescriptionMedicine.motiveSuspended;
          this.prescriptionMedicineStruct.prescriptionMedicine.idPrescriptionStatus = result.medicalPrescriptionToSuspend.prescriptionMedicine.idPrescriptionStatus;
          this.matDialogRef.close({ prescription: this.prescriptionMedicineStruct });
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }
}